import { Component, OnInit } from '@angular/core';
import {UtilService} from '../../services/utilService/util.service';
import {SuperAdminService} from '../../services/apiCalls/superAdminService/super-admin.service';
import {IResponse} from '../../interfaces/iresponse';
import {BootstrapNotifyService} from '../../services/bootstrap-notify/bootstrap-notify.service';

@Component({
  selector: 'app-payment-channel',
  templateUrl: './payment-channel.component.html',
  styleUrls: ['./payment-channel.component.css']
})
export class PaymentChannelComponent implements OnInit {
  breadCrumb: any;
  showData = false;
  public paymentChannel: any[] = [];
  loadingData = false;
  loaders = {
    saving: false
  };
  modal = {
    title: 'Create Payment Channel',
    btnText: 'SAVE'
  };
  activeChannel = null;
  channel =  {
    payment_channel: null,
    payment_channel_description: null,
    is_active: false
  };
  constructor(private utilService: UtilService,
              private bootstrapNotify: BootstrapNotifyService,
              private superAdminService: SuperAdminService) { }

  ngOnInit() {
    this.breadCrumb  = {
      name: 'Payment Channel',
      parent: 'Settings',
      subLink: null
    };
    this.getPaymentChannel();
  }

  getPaymentChannel() {
    this.loadingData = true;
    this.showData = false;
    this.paymentChannel = [];
    this.superAdminService.getPaymentChannels()
      .subscribe((res: IResponse) => {
        console.log('Response ', res);
        this.paymentChannel = res.data;
        this.utilService.startDatatable('all-channels');
        this.loadingData = false;
        this.showData = true;
      }, error => {
        console.log('Error ', error);
        this.utilService.startDatatable('all-channels');
        this.loadingData = false;
        this.showData = true;
      });
  }


  openDialog(id) {
    this.modal = {
      title: 'Create Payment Channel',
      btnText: 'SAVE'
    };
    this.activeChannel = null;
    this.resetForm();
    this.utilService.openModal(id);
  }

  public deleteChannel(channel) {
    this.utilService.confirmAction(() => {
      this.superAdminService.deletePaymentChannel(channel.id)
        .subscribe((res: IResponse) => {
          console.log('Res ', res);
          this.getPaymentChannel();
        }, error => {
          console.log('Errro ', error);

        });
    });
  }
  public triggerEdit(channel) {
    this.activeChannel = JSON.parse(JSON.stringify(channel));
    this.resetForm();
    this.utilService.openModal('createChannel');
    this.channel = this.activeChannel;
    this.modal = {
      title: 'Update Payment Channel',
      btnText: 'UPDATE'
    };
  }

  public resetForm() {
    this.channel =  {
      payment_channel: null,
      payment_channel_description: null,
      is_active: false
    };
  }
  public createChannel() {
    console.log('Channel ', this.channel);
    this.loaders.saving = true;
    if (!this.channel.payment_channel) {
      this.bootstrapNotify.info('Payment Channel field is Required');
      this.loaders.saving = false;
    } else if (!this.channel.payment_channel_description) {
      this.bootstrapNotify.info('Payment Channel description field is Required');
      this.loaders.saving = false;
    } else {
      if (this.activeChannel) {
        this.updateChannel();
      } else {
        this.superAdminService.createPaymentChannel(this.channel).subscribe((response: IResponse) => {
          console.log('Response', response);
          this.loaders.saving = false;
          this.resetForm();
          this.getPaymentChannel();
          this.utilService.closeModal('createChannel');
        }, error => {
          this.bootstrapNotify.error(error.error.message || 'Unable to create payment channel!', 'right');
          this.loaders.saving = false;
          console.info('Error => ', error);
        });
      }
    }

  }
  public updateChannel() {
    this.superAdminService.updatePaymentChannel(this.channel, this.activeChannel.id).subscribe((response: IResponse) => {
      console.log('Response', response);
      this.loaders.saving = false;
      this.resetForm();
      this.getPaymentChannel();
      this.utilService.closeModal('createChannel');
    }, error => {
      this.bootstrapNotify.error(error.error.message || 'Unable to update payment channel!', 'right');
      this.loaders.saving = false;
      console.info('Error => ', error);
    });
  }
  public makeChannel(status, channel) {
    this.superAdminService.updatePaymentChannel({is_active: status,
      payment_channel_description: channel.payment_channel_description,
      payment_channel: channel.payment_channel}, channel.id).subscribe((response: IResponse) => {
      console.log('Response', response);
      this.getPaymentChannel();
    }, error => {
      this.bootstrapNotify.error(error.error.message || 'Unable to update payment channel!', 'right');
      this.loaders.saving = false;
      console.info('Error => ', error);
    });
  }
}
